/*
 * GRIG home 2, S11 newsletter (sections/grig-home-newsletter.liquid).
 *
 * The private lifecycle newsletter (snippets/grig-newsletter-lifecycle.liquid, rendered once by layout/theme.liquid
 * before the footer) owns the real signup: assets/grig-newsletter-lifecycle.js binds exactly its two forms (inline and
 * popup) and keeps references to them. This script does not touch that logic. Once the lifecycle root reports ready
 * (data-newsletter-ready, event grig:newsletter-ready) it moves the live inline form body into this card in place of
 * the server placeholder, so the homepage offers one signup with unique ids, and moves it back on section unload
 * (theme editor). Without the lifecycle (other themes), when it is not authorized (root hidden) or without JS, the
 * disabled placeholder stays: the lifecycle's own honest "not connected" state.
 *
 * Runs through window.GRIGHome.register (re-init after shopify:section:load, cleanup on unload); falls back to a
 * plain DOMContentLoaded init when grig-home.js is absent.
 */
(function () {
  'use strict';

  var ROOT = '[data-grig-newsletter]';
  var SECTION = '[data-gh-section="newsletter"]';
  var active = typeof WeakSet === 'function' ? new WeakSet() : null;

  function lifecycleRoot() {
    var root = document.querySelector(ROOT);
    if (!root || root.hidden || root.getAttribute('data-newsletter-ready') !== 'true') return null;
    return root;
  }

  function adopt(section) {
    var slot = section.querySelector('[data-ghnl-slot]');
    var placeholder = slot && slot.querySelector('[data-ghnl-placeholder]');
    var root = lifecycleRoot();
    if (!slot || !placeholder || !root || root.hasAttribute('data-ghnl-adopted')) return null;
    var form = root.querySelector('[data-newsletter-form][data-newsletter-source="inline"]');
    var body = form && form.closest('[data-newsletter-body]');
    if (!body || !root.contains(body)) return null;

    var state = {
      root: root,
      slot: slot,
      body: body,
      parent: body.parentNode,
      next: body.nextSibling,
      placeholder: placeholder,
      labelledby: root.getAttribute('aria-labelledby')
    };
    slot.replaceChild(body, placeholder);
    root.setAttribute('data-ghnl-adopted', '');
    // The root's own heading is hidden with its inline block: keep it from being announced as an empty region.
    if (state.labelledby !== null) root.removeAttribute('aria-labelledby');
    slot.setAttribute('data-ghnl-live', '');
    section.dispatchEvent(new CustomEvent('ghnl:adopted', { bubbles: true }));
    return state;
  }

  function release(state) {
    var body = state.body;
    if (state.parent && state.parent.isConnected) {
      var next = state.next && state.next.parentNode === state.parent ? state.next : null;
      state.parent.insertBefore(body, next);
    }
    if (state.slot.isConnected && !state.placeholder.isConnected) state.slot.appendChild(state.placeholder);
    state.slot.removeAttribute('data-ghnl-live');
    state.root.removeAttribute('data-ghnl-adopted');
    if (state.labelledby !== null) state.root.setAttribute('aria-labelledby', state.labelledby);
  }

  function init(section) {
    if (active) {
      if (active.has(section)) return undefined;
      active.add(section);
    }
    var state = null;

    function attempt() {
      if (!state && section.isConnected) state = adopt(section);
      if (state) document.removeEventListener('grig:newsletter-ready', attempt);
    }

    attempt();
    if (!state) document.addEventListener('grig:newsletter-ready', attempt);

    return function cleanup() {
      document.removeEventListener('grig:newsletter-ready', attempt);
      if (state) release(state);
      state = null;
      if (active) active.delete(section);
    };
  }

  (window.GRIGHomeReady = window.GRIGHomeReady || []).push(function (GH) {
    GH.register('newsletter', init);
  });

  function fallback() {
    if (window.GRIGHome) return;
    Array.prototype.forEach.call(document.querySelectorAll(SECTION), function (section) { init(section); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fallback, { once: true });
  else if (document.readyState === 'interactive') window.addEventListener('load', fallback, { once: true }); // after every deferred script, so grig-home.js (GRIGHome) always wins the init and owns the unload cleanup
  else window.setTimeout(fallback, 0);
})();
